module.exports = __webpack_public_path__ + "img/btn-replayedit-disable.8414bdcb.svg";